// extracted by mini-css-extract-plugin
export var infoRow = "_u6-2";
export var labelContainer = "_u6-0";
export var rightInfo = "_u6-1";